import type { CSSProperties, ReactNode } from 'react';

interface TileProps {
  children: ReactNode;
  padding?: string;
  onClick?: () => void;
  style?: CSSProperties;
}

export function Tile({ children, padding = '0', onClick, style }: TileProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={{
        backgroundColor: 'var(--mantine-color-dark-7)',
        border: '1px solid var(--mantine-color-dark-5)',
        borderRadius: '8px',
        padding,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        ...style,
      }}
      className="tile-hover"
    >
      {children}
      <style>{`
        .tile-hover:hover {
          background-color: var(--mantine-color-dark-6) !important;
          border: 1px solid var(--mantine-color-blue-7) !important;
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
        }
      `}</style>
    </div>
  );
}
